import { Image, StyleSheet } from 'react-native';
// eslint-disable-next-line import/default
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';

import { colors } from '../../theme';
import SplashImage from '../../assets/images/splash.png';

export const SplashScreen = ({ noImage = false }) => {
	return (
		<Animated.View
			style={styles.root}
			entering={FadeIn.duration(100)}
			exiting={FadeOut.duration(350)}
		>
			{!noImage && <Image source={SplashImage} resizeMode="contain" style={styles.image} />}
		</Animated.View>
	);
};

const styles = StyleSheet.create({
	root: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		backgroundColor: colors.background200,
	},
	image: { width: '100%', height: '100%' },
});
